export default "__VITE_ASSET__Rjjd_f8u__"